module.exports = __webpack_public_path__ + "static/media/Karnatka.fcb0e365.png";